import { FETCH_FAQ, FETCH_LANDING_CONTENT, SET_ACTIVE_FAQ } from './constants'
import { CLEAR_CONTENT } from '../App/constants'

const initialState = {
  isFetching: false,
  isFetchingLanding: false,
  questions: [],
  landingCategories: [],
  currentPhoneId: '',
  activeFAQ: {
    faqId: null,
    faqName: '',
    faqSlug: '',
    faqVal: ''
  }
}

export default function faqReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FAQ.REQUEST: {
      return {
        ...state,
        isFetching: true,
        questions: []
      }
    }
    case FETCH_FAQ.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        questions: action.questions.faqs,
        currentPhoneId: action.currentPhoneId
      }
    }
    case '@@router/LOCATION_CHANGE': {
      return {
        ...state,
        activeFAQ: {
          faqId: null,
          faqName: '',
          faqSlug: '',
          faqVal: ''
        }
      }
    }
    case SET_ACTIVE_FAQ: {
      return {
        ...state,
        activeFAQ: action.activeFAQ
      }
    }

    case FETCH_LANDING_CONTENT.REQUEST: {
      return {
        ...state,
        isFetchingLanding: true,
        landingCategories: []
      }
    }
    case FETCH_LANDING_CONTENT.SUCCESS: {
      return {
        ...state,
        isFetchingLanding: false,
        landingCategories: action.landingCategories.faqs
      }
    }
    case CLEAR_CONTENT: {
      return {
        ...state,
        tutorials: []
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/FAQs/reducer.js